import { useState } from "react";
// local import
import "./style.scss";

const Card = ({ content }) => {
  const [isLoading, setLoading] = useState(false);

  const onImageLoading = () => {
    setLoading(true);
  };

  const onLoadingError = () => {
    console.log("Error while loading image");
  };

  return (
    <div className="containerCard">
      <div className="boxCard">
        {!isLoading && (
          <div className="spinner">
            <div className="card-spinner" />
          </div>
        )}
        <img
          src={content.img}
          onLoad={onImageLoading}
          onError={onLoadingError}
          alt={content.title}
          className={isLoading ? "imgCard" : "invisible"}
        />

        <h2 className="hTitle">{content.title}</h2>
        <div className="contentBox">
          <p>{content.description}</p>
          <a
            href={content.link}
            className="aLink"
            target="_blank"
            rel="noreferrer noopener"
          >
            Click for more
          </a>
        </div>
      </div>
    </div>
  );
};

export default Card;
